(function () {
  'use strict';

  var config = {
    base: 'COP',
    storageKey: 'snaau_display_currency',
    rates: {
      COP: 1,
      USD: 0.0003087,
      EUR: 0.0002758,
      GBP: 0.0002338
    },
    fractionDigits: {
      COP: 0,
      USD: 2,
      EUR: 2,
      GBP: 2
    }
  };

  var currencyNames = {
    COP: 'Colombian Peso',
    USD: 'US Dollar',
    EUR: 'Euro',
    GBP: 'British Pound'
  };

  var selector = [
    '.money',
    '.price-item',
    '.hz__predictiveSearchV2ProductPrice',
    '.cart-item__old-price',
    '.cart-item-value',
    '.cart-total-value .text',
    '[data-cart-discount-amount]',
    '.previewCartItem-price .price',
    '.previewCartTotals-value',
    '.previewCartTotals-value .text',
    '[data-snaau-currency-price]'
  ].join(',');

  function validCurrency(code) {
    return Object.prototype.hasOwnProperty.call(config.rates, code);
  }

  function getCurrency() {
    var stored = null;
    try {
      stored = sessionStorage.getItem(config.storageKey);
    } catch (e) {}
    return validCurrency(stored) ? stored : config.base;
  }

  function setCurrency(code) {
    if (!validCurrency(code)) return;
    try {
      sessionStorage.setItem(config.storageKey, code);
    } catch (e) {}
    window.SnaauDisplayCurrency.current = code;
  }

  function parseMoney(value) {
    var text = String(value || '').replace(/<[^>]*>/g, '').trim();
    var negative = /^\s*-/.test(text);
    var matches = text.match(/\d[\d.,]*/g);
    if (!matches || !matches.length) return null;

    var raw = matches[matches.length - 1];
    var lastDot = raw.lastIndexOf('.');
    var lastComma = raw.lastIndexOf(',');
    var number;

    if (lastDot > -1 && lastComma > -1) {
      var decimalSeparator = lastDot > lastComma ? '.' : ',';
      var thousandsSeparator = decimalSeparator === '.' ? ',' : '.';
      raw = raw.split(thousandsSeparator).join('');
      raw = raw.replace(decimalSeparator, '.');
      number = parseFloat(raw);
    } else if (lastDot > -1 || lastComma > -1) {
      var separator = lastDot > -1 ? '.' : ',';
      var parts = raw.split(separator);
      if (parts.length === 2 && parts[1].length > 0 && parts[1].length <= 2) {
        number = parseFloat(parts[0].replace(/\D/g, '') + '.' + parts[1]);
      } else {
        number = parseFloat(parts.join(''));
      }
    } else {
      number = parseFloat(raw);
    }

    if (!Number.isFinite(number)) return null;
    return negative ? -number : number;
  }

  function getBaseValue(element) {
    var stored = element.getAttribute('data-snaau-base-price');
    if (stored !== null && stored !== '') {
      var storedNumber = Number(stored);
      if (Number.isFinite(storedNumber)) return storedNumber;
    }

    var source = element.getAttribute('data-snaau-source-price');
    if (source !== null && source !== '') {
      var sourceNumber = Number(source);
      if (Number.isFinite(sourceNumber)) {
        element.setAttribute('data-snaau-base-price', String(sourceNumber));
        return sourceNumber;
      }
    }

    var parsed = parseMoney(element.textContent);
    if (parsed === null) return null;
    element.setAttribute('data-snaau-base-price', String(parsed));
    return parsed;
  }

  function format(value, currency) {
    var digits = config.fractionDigits[currency];
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(value);
    } catch (e) {
      return currency + ' ' + value.toFixed(digits);
    }
  }

  function updateLabel(currency) {
    var labels = document.querySelectorAll('[data-currency-label] .text, [data-snaau-currency-label]');
    labels.forEach(function (label) {
      label.textContent = currency;
    });

    document.querySelectorAll('#currencies [data-currency]').forEach(function (item) {
      var active = item.getAttribute('data-currency') === currency;
      item.classList.toggle('active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function convertElement(element, currency) {
    if (!element || element.closest('[data-snaau-currency-selector]')) return;

    var baseValue = getBaseValue(element);
    if (baseValue === null) return;

    var converted = baseValue * config.rates[currency];
    element.textContent = format(converted, currency);
    element.setAttribute('data-snaau-display-currency', currency);
  }

  function apply(root) {
    var currency = getCurrency();
    var scope = root || document;
    var elements = [];

    if (scope.matches && scope.matches(selector)) elements.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll(selector).forEach(function (element) {
        elements.push(element);
      });
    }

    elements.forEach(function (element) {
      convertElement(element, currency);
    });

    updateLabel(currency);
  }

  function choose(currency) {
    if (!validCurrency(currency)) return;
    setCurrency(currency);
    updateLabel(currency);
    apply(document);
  }

  function init() {
    window.SnaauDisplayCurrency = window.SnaauDisplayCurrency || {};
    window.SnaauDisplayCurrency.config = config;
    window.SnaauDisplayCurrency.names = currencyNames;
    window.SnaauDisplayCurrency.current = getCurrency();
    window.SnaauDisplayCurrency.set = choose;
    window.SnaauDisplayCurrency.apply = apply;

    document.addEventListener('click', function (event) {
      var item = event.target.closest && event.target.closest('#currencies [data-currency]');
      if (!item) return;

      event.preventDefault();
      event.stopPropagation();
      choose(item.getAttribute('data-currency'));
    }, true);

    apply(document);

    var observer = new MutationObserver(function (mutations) {
      var hasAddedNodes = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) { return node.nodeType === 1; });
      });
      if (hasAddedNodes) apply(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', function (event) {
      apply(event.target || document);
    });

    document.addEventListener('shopify:section:reorder', function () {
      apply(document);
    });

    document.addEventListener('shopify:section:select', function () {
      apply(document);
    });

    window.addEventListener('pageshow', function () {
      apply(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();